import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { CarJobTemplate } from 'src/app/public/car/models/car-job-template.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { KeepBasicData } from 'src/app/public/keep/constants/keep-basic-data';


@Component({
    selector: 'app-carref-job-templates',
    templateUrl: './carref-job-templates.component.html',
    styleUrl: './carref-job-templates.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefJobTemplatesComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() jobTemplates: CarJobTemplate[] = [];
  @Input() jobTasks: CarJobTask[] = [];

  newItem: CarJobTemplate = new CarJobTemplate('', '');
  editedItem: CarJobTemplate = new CarJobTemplate('', '');

  displayedColumns: string[] = ['id', 'code','title', 'category', 'tasks', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarJobTemplate>(this.jobTemplates);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  jobCategories = KeepBasicData.carJobCategories;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.jobTemplatesFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['jobTemplates']){
      this.dataSource.data = changes['jobTemplates'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarJob('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarJobTemplate('','');
      this.dataSource.data = [...this.dataSource.data, new CarJobTemplate('','')];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.jobs.find((manuf: CarJob) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.jobTemplates.find((item: CarJobTemplate) => item.id === id) );
    //console.log(this.editedItem);
  }

  saveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.jobs.find((manuf: CarJob) => manuf.id === id));
    this.editedItem = Object.assign({}, this.jobTemplates.find((jobTemplate: CarJobTemplate) => jobTemplate.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.jobTemplateNewSubmit({jobTemplate: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.jobTemplateUpdateSubmit({jobTemplate: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(jobTemplate => jobTemplate.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.jobTemplateDeleteSubmit({jobTemplateId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.title.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
